/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const GlobalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="GlobalIcon">
    <path
      d="M9 17.333A8.333 8.333 0 1 1 9 .667a8.333 8.333 0 1 1 0 16.666ZM7.09 15.39A14.917 14.917 0 0 1 5.69 9.833H2.385a6.673 6.673 0 0 0 4.707 5.556Zm.267-5.556A13.262 13.262 0 0 0 9 15.46a13.255 13.255 0 0 0 1.642-5.627H7.358Zm8.257 0H12.31a14.919 14.919 0 0 1-1.403 5.556 6.674 6.674 0 0 0 4.707-5.556ZM2.385 8.167h3.304c.104-1.926.58-3.812 1.402-5.556a6.673 6.673 0 0 0-4.706 5.556Zm4.974 0h3.282A13.254 13.254 0 0 0 9 2.54a13.254 13.254 0 0 0-1.642 5.627h.001Zm3.55-5.556a14.919 14.919 0 0 1 1.402 5.556h3.304a6.672 6.672 0 0 0-4.707-5.556Z"
      fill="currentColor"
    />
  </svg>
);

export default GlobalIcon;
